import { useContext } from 'react';
import { MessageDescriptor } from 'react-intl';
import { IntlProviderContext } from './IntlProviderContext';

export type FormatMessage = (
  id: MessageDescriptor['id'],
  defaultMessage: MessageDescriptor['defaultMessage'],
  values?: { [key: string]: any }
) => string;

export const useFormatMessage = () => {
  const { formatMessage } = useContext(IntlProviderContext);

  // HACK for storybook missing translation funct
  if (!formatMessage) return (_key: string, fallback: string) => fallback;

  const formatMessageFn: FormatMessage = (id, defaultMessage, values) =>
    formatMessage({ id, defaultMessage }, values);

  return formatMessageFn;
};

export const useCurrency = () => {
  const { formatNumber } = useContext(IntlProviderContext);

  const formatCurrency = ({
    value,
    currency = 'EUR',
  }: {
    value: number;
    currency?: string;
  }) => {
    const formated = formatNumber(value, {
      style: 'currency',
      currency: currency,
    });

    return formated;
  };

  return formatCurrency;
};
